var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriorityDm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 8.5,
    fill: "#F7F7F7",
    stroke: "#EBEAEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.666 13.332H13.3327C12.4122 13.332 11.666 14.0782 11.666 14.9987V24.9987C11.666 25.9192 12.4122 26.6654 13.3327 26.6654H26.666C27.5865 26.6654 28.3327 25.9192 28.3327 24.9987V14.9987C28.3327 14.0782 27.5865 13.332 26.666 13.332Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3327 15.832L20.8577 20.582C20.6004 20.7432 20.3029 20.8287 19.9993 20.8287C19.6958 20.8287 19.3983 20.7432 19.141 20.582L11.666 15.832",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityDm);
export default __webpack_public_path__ + "static/media/priorityDm.f7f92af344acca72c0a0c86b355776a2.svg";
export { ForwardRef as ReactComponent };